import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Checkmark, ChevronRight } from '../../icons';
import { Typography } from '../Typography/Typography';
import styles from './Stepper.module.scss';
import { stepperStepTestId } from './Stepper.utils';
export function Stepper(_0) {
    let { className, steps, activeStepId, onStepClick, variant = 'text', testId } = _0, rest = _object_without_properties(_0, [
        "className",
        "steps",
        "activeStepId",
        "onStepClick",
        "variant",
        "testId"
    ]);
    const isNumbered = variant === 'numbered';
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        className: cn(styles.root, {
            [styles.numbered]: isNumbered
        }, className),
        "data-testid": testId
    }, rest), {
        children: steps.map((step, index)=>{
            var _step_testId;
            const isActive = step.id === activeStepId;
            return /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    step.completed && !isNumbered && /*#__PURE__*/ _jsx("span", {
                        className: styles.checkmark,
                        "data-testid": step.testId && "".concat(step.testId, "-completed"),
                        children: /*#__PURE__*/ _jsx(Checkmark, {})
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        as: "button",
                        variant: "paragraph1",
                        weight: isActive ? 'normal' : 'light',
                        className: cn({
                            [styles.numberedStep]: isNumbered
                        }),
                        skin: step.disabled ? 'disabled' : undefined,
                        disabled: step.disabled,
                        testId: (_step_testId = step.testId) !== null && _step_testId !== void 0 ? _step_testId : stepperStepTestId(testId, step.id),
                        onClick: ()=>onStepClick && onStepClick(step),
                        children: [
                            isNumbered && /*#__PURE__*/ _jsx("span", {
                                className: cn(styles.marker, {
                                    [styles.active]: isActive,
                                    [styles.completed]: step.completed && !isActive
                                }),
                                children: step.completed && !isActive ? /*#__PURE__*/ _jsx(Checkmark, {}) : index + 1
                            }),
                            step.completed || isNumbered ? step.label : "".concat(index + 1, ". ").concat(step.label)
                        ]
                    }),
                    index !== steps.length - 1 && /*#__PURE__*/ _jsx("span", {
                        className: cn(styles.separator, {
                            [styles.connector]: isNumbered
                        }),
                        children: !isNumbered && /*#__PURE__*/ _jsx(ChevronRight, {})
                    })
                ]
            }, step.id);
        })
    }));
}
